import React from 'react';

import { Translator } from 'ggApp/modules/translator/components';
import { Wrapper, Headline, Description } from './styles';

export type AnnouncementProps = {
    className?: string;
    productAnnouncementData: {
        pdpHeadline: string;
        pdpDescription: string;
    };
};

export const Announcement = ({
    className,
    productAnnouncementData: { pdpHeadline, pdpDescription },
}: AnnouncementProps): JSX.Element => (
    <Wrapper className={className} data-testid="announcement-component">
        <Headline>
            <Translator tk={pdpHeadline} />
        </Headline>
        <Description>
            <Translator tk={pdpDescription} />
        </Description>
    </Wrapper>
);
